













import { defineComponent } from '@vue/composition-api';
import { VImg, VBtn } from 'vuetify/lib';
import { useCDN } from '@/utils/cdn.utils';

export default defineComponent({
  name: 'SubscriptionUpgradeBanner',
  components: {
    VImg,
    VBtn
  },

  setup() {
    const { cdn } = useCDN();

    return {
      cdn
    };
  }
});
